import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { VEHICLE_TYPE } from '@/utils/constants'
import { hasNewCardLayout } from '@/utils/utils'

import useFilter from '@/modern/actions/useFilter'
import { oportunitiesAPI } from '@/modern/services/api'

import * as S from './styles'

const OpportunitiesFilterItem = ({
  opportunity,
  addUrl,
  beginSearchLoad,
  filterChange,
  handleSelect,
  vehicleType,
  testIdPrefix,
  dataQA,
}) => {
  const { toggleFilter, setFilter } = useFilter(opportunity.id)
  const dataTestId = `${testIdPrefix}_${opportunity.id}`
  const dataTestComponent = `${testIdPrefix}_option`
  const LabelDataQA = dataQA ? `${dataQA}_${opportunity.id}` : undefined

  const handleFilter = () => {
    handleSelect(opportunity)
    beginSearchLoad()
    setTimeout(() => {
      oportunitiesAPI.all(vehicleType).then(res => {
        filterChange(res.data)
      })
    }, 40)
    toggleFilter()
    addUrl()
  }

  useEffect(() => {
    setFilter(opportunity.selected)
  }, [opportunity.selected, setFilter])

  const hasNewCardTestAB = hasNewCardLayout()

  return (
    <div>
      <S.Checkbox
        data-qa={LabelDataQA}
        data-test-component={dataTestComponent}
        data-testid={dataTestId}
      >
        <S.Input
          type="checkbox"
          checked={opportunity.selected}
          onChange={handleFilter}
        />
        <S.WrapperContent>
          <S.WrapperTitle>
            <S.FilterText>{opportunity.displayName}</S.FilterText>
            {!hasNewCardTestAB && opportunity.showBadge && (
              <S.Badge
                alt={opportunity.displayName}
                width="28px"
                height="49px"
                src={`/assets/img/stamps/${opportunity.badge}.svg`}
              />
            )}
          </S.WrapperTitle>
        <S.Description>{opportunity.description}</S.Description>
          </S.WrapperContent>
        </S.Checkbox>
    </div>
  )
}

OpportunitiesFilterItem.propTypes = {
  addUrl: PropTypes.func.isRequired,
  beginSearchLoad: PropTypes.func.isRequired,
  filterChange: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  opportunity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    selected: PropTypes.bool.isRequired,
    showBadge: PropTypes.bool.isRequired,
    badge: PropTypes.string.isRequired,
  }).isRequired,
  vehicleType: PropTypes.oneOf([VEHICLE_TYPE.car, VEHICLE_TYPE.bike])
    .isRequired,
  testIdPrefix: PropTypes.string.isRequired,
  dataQA: PropTypes.string,
}

OpportunitiesFilterItem.defaultProps = {
  dataQA: '',
}

export default OpportunitiesFilterItem
